import React from 'react'
import styled from 'styled-components'
import { colors } from '../styles/vars'

const Container = styled.div`
background-color:${colors.white};
border-radius:50%;
width: 40px;
cursor: pointer;
margin:0 10px 0 0;
overflow:hidden;
display:flex;
flex-direction:column;
justify-content:center;
`
const Stripe = styled.div`
height:3px;
margin:4px auto 0;
border-radius:7px;
width:60%;
background-color:#ab4445;
will-change:transform;
backface-visibility:hidden;
transition:transform .5s, background-color .5s;
transform:${props => props.active ? 'translate3d(150%,0,0)' : 'translate3d(0,0,0)'};
&:first-child{
    margin-top:0;
    transform:${props => props.active ? 'translate3d(0,8px,0) rotate(39deg)' : 'translate3d(0,0,0)'};
}
&:last-child{
    transform:${props => props.active ? 'translate3d(0,-7px,0) rotate(-39deg)' : 'translate3d(0,0,0)'}; 
}
`

const Burger = (props) => {
    return (
        <Container
            onClick={props.onClick}
            active={props.isActive}
        >
            <Stripe active={props.isActive} />
            <Stripe active={props.isActive} />
            <Stripe active={props.isActive} />
        </Container>
    )
}

export default Burger;


// WEBPACK FOOTER //
// ./src/components/Burger.jsx